import React, { useMemo, useState } from "react";

import CountUp from "react-countup";
import { twMerge } from "tailwind-merge";

import { SupIconButton } from "@repo/core-ui";
import { SupEye } from "@repo/core-ui";

import { formatCurrencyCompact } from "@/utils";
import useTokenSuperpositionsBalances from "@/hooks/api/useTokenSuperpositionsBalances";

interface CredHomeHeroPortfolioProps {
  className?: string;
}

export default function CredHomeHeroPortfolio({ className }: CredHomeHeroPortfolioProps) {
  const { isLoading, data } = useTokenSuperpositionsBalances();

  const [isHidden, setIsHidden] = useState(false);

  const handleClick = () => {
    setIsHidden(currentState => !currentState);
  };

  const portfolioValue = data?.portfolioValue;
  const showPulse = useMemo(() => isHidden || isLoading || portfolioValue === undefined, [isHidden, isLoading, portfolioValue]);

  return (
    <div className={twMerge("", className)}>
      <div className="mx-auto w-fit">
        <div className="text-center">
          {portfolioValue !== undefined && (
            <SupIconButton onClick={handleClick} className="text-neutral-900" active={isHidden} activeClassName="text-neutral-200">
              <SupEye />
            </SupIconButton>
          )}
        </div>
        <div className="text-center font-[MicrogrammaDExtended] font-bold uppercase tracking-wide">
          <div className="text-xs leading-4 text-neutral-900">Portfolio Value</div>
          <div className="h-8 text-xl leading-8 text-neutral-925">
            {showPulse ? (
              <div className={twMerge("inline-flex h-4 w-full rounded-full bg-primary-900/50", isLoading && "animate-pulse")} />
            ) : (
              <CountUp decimals={2} start={0} duration={2} end={portfolioValue as number} formattingFn={val => formatCurrencyCompact(val, 2, 2)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
